import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import reportWebVitals from './reportWebVitals';
import store from './store/store';
import { fetchUserAsync } from './store/userSlice';
import { ModalStack } from '@mattjennings/react-modal-stack'

import App from './App';

console.log("Fetching user ...");
store.dispatch(fetchUserAsync());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <ModalStack>
        <App/>
    </ModalStack>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
